// @vendors
import React, { useContext, useMemo } from 'react'
import { useHistory } from 'react-router-dom';

// @components material
import {
  AddIcon,
  Button,
  Grid,
  Box,
  IconButton,
  SearchRoundedIcon,
  Tooltip,
  ClearAllIcon,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '../../../components/shared/MaterialUI';

// @assets
import { GeneralStyles } from '../../../assets/css/general-style';

// @constants
import { ROUTENAME } from '../../../navigation/RouteName';

// @context
import { UserContext } from '../UserManagement';
import { MenuItemProps } from '../../../helpers/FunctionsUtils';
import { LISTROLES_ARRAY } from '../../../helpers/ListRoles';
import { theme } from '../../../assets/theme';

const ToolbarUser = () => {
  const styles = useMemo(() => GeneralStyles(), []);
  const history = useHistory();
  const {
    getUsers,
    search,
    setSearch,
    pages
  } = useContext(UserContext)

  const onSearchBarChange = (e) => {
    setSearch((current) => ({
      ...current,
      fullName: e.target.value
    }));
  };

  const clearSearch = () => {
    setSearch((current) => ({
      ...current,
      fullName: '',
      permission: ''
    }));
    getUsers(1, pages.size, {});
  };

  const handleSearchBar = async () => {
    getUsers(1, pages.size);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setSearch(prev => ({...prev, permission: value}));
  }

  return (
    <Box sx={styles.containerToolbar}>
        <Grid
          container
          spacing={2}
          sx={{
              display: 'flex',
              justifyContent: 'start',
              alignItems: 'center',
              gap: '10px'
            }}
          >

          <Grid item xs={12} sm={2} md={1} lg={1} sx={{width: '100%'}}>
            <h2 style={{color: theme.palette.primary.black}}>User list</h2>
          </Grid>

          <Grid item xs={12} sm={4} md={3} lg={3} sx={{width: '100%'}}>
            <TextField
              sx={{
                ...styles.input,
                ...styles.customButtonSm,
              }}
              value={search?.fullName}
              id='searchCompany'
              placeholder='Full name'
              onChange={(e) => onSearchBarChange(e)}
              variant='outlined'
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={4} md={3} lg={3} sx={{width: '100%'}}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Permission</InputLabel>
              <Select
                  id="demo-simple-select"
                  labelId="demo-simple-select-label"
                  label="Permission"
                  value={search?.permission}
                  onChange={(e) => {handleChange(e);}}
                  MenuProps={MenuItemProps}
                  sx={{
                    ...styles.input,
                    ...styles.customButtonSm,
                  }}
              >
                  {LISTROLES_ARRAY?.map((item, index) => (
                      <MenuItem
                          value={item.value}
                          key={index}
                      >
                          {item.name}
                      </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={3} sm={2} md={2} lg={2} sx={{width: '100%'}}>
            <Tooltip title="Search">
              <IconButton
                onClick={() => handleSearchBar()}
                sx={styles.iconButtonSearch}
              >
                <SearchRoundedIcon />
              </IconButton>
            </Tooltip>
            
            <Tooltip title="Clear filter">
              <IconButton
                onClick={() => clearSearch()}
                sx={styles.iconButtonSearch}
              >
                <ClearAllIcon />
              </IconButton>
            </Tooltip>
          </Grid>

          <Grid item xs={8} sm={4} md={3} lg={2} sx={{width: '100%'}}>
            <Button
              endIcon={<AddIcon />}
              sx={styles.customButtonMain}
              onClick={() => history.push(ROUTENAME.addUser)}
            >
              Add New User
            </Button>
          </Grid> 
        </Grid>
    </Box>
  )
}

export default ToolbarUser